import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
// import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DialogComponent } from '../../../ui/dialog/dialog';
import { DialogLightComponent } from '../../../ui/dialog-light/dialog-light';
// import { ActivatedRoute } from '@angular/router';

import { ApiProvider } from '../../../providers/api/api';
import { HelpersProvider } from '../../../providers/helpers/helpers';
import { AuthService } from '../../../providers/auth/auth.service';
import { CustomerProvider } from '../../../providers/customer/customer';
import { UserProvider } from '../../../providers/user/user';
import { FileProvider } from '../../../providers/file/file';
import { I18nProvider } from '../../../providers/i18n/i18n';


@Component({
  selector: 'component-customer-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss']
})
export class CustomerFilesComponent implements OnInit, OnChanges {
  protected headers: any;
  @Input() studentData: any = null;

  @Output() closeFiles = new EventEmitter<void>();
  @Output() filesUpdated = new EventEmitter<{id: number, files: any[]}>();

  search = '';
  activeFilter = 'all';
  filters = [
    {id: 'all', label: 'Todos'}, {id: 'unsent', label: 'Não enviados'},
    {id: 'pdf', label: 'PDF'}, {id: 'img', label: 'Imagens'},
    {id: 'doc', label: 'Documentos'}, {id: 'xls', label: 'Planilhas'},
    {id: 'vid', label: 'Vídeos'}
  ];
  selectedFiles = new Set<number>();
  sending = false;
  removingFileId: number = null;
  uploading = false;
  loadError = false;
  private loadVersion = 0;

  get filteredFiles(): any[] {
    const term = this.helpers.removeDiacritics(this.search.trim().toLowerCase());
    return this.files.filter(file => {
      const name = this.helpers.removeDiacritics((file.name || '').toLowerCase());
      return (!term || name.includes(term)) && (this.activeFilter === 'all' ||
        (this.activeFilter === 'unsent' ? !this.studentHasDoc(this.studentData, file.id) :
          this.fileType(file) === this.activeFilter));
    });
  }

  fileType(file: any): string {
    const extension = (file.name || file.path || '').split(/[?#]/)[0].split('.').pop().toLowerCase();
    const mime = (file.mime_type || file.type || '').toLowerCase();
    if (extension === 'pdf' || mime === 'application/pdf') return 'pdf';
    if (/^(png|jpe?g|gif|webp|svg|heic|bmp)$/.test(extension) || mime.startsWith('image/')) return 'img';
    if (/^(xlsx?|csv|ods)$/.test(extension) || /spreadsheet|excel|csv/.test(mime)) return 'xls';
    if (/^(mp4|mov|webm|avi|mkv)$/.test(extension) || mime.startsWith('video/')) return 'vid';
    return 'doc';
  }

  fileIcon(file: any): string {
    return {pdf: 'picture_as_pdf', img: 'image', doc: 'description', xls: 'table_chart', vid: 'play_circle_outline'}[this.fileType(file)];
  }

  fileSize(file: any): string {
    const size = Number(file.size);
    if (!isFinite(size) || size < 0) return '—';
    return size < 1024 * 1024 ? (size / 1024).toFixed(1) + ' KB' : (size / (1024 * 1024)).toFixed(2) + ' MB';
  }

  toggleSelection(file: any) {
    if (this.loading || this.sending || this.removingFileId != null || this.uploading || this.loadError || !this.studentData ||
        this.studentHasDoc(this.studentData, file.id)) return;
    if (this.selectedFiles.has(file.id)) this.selectedFiles.delete(file.id);
    else this.selectedFiles.add(file.id);
  }

  async sendFiles() {
    if (this.loading || this.sending || this.removingFileId != null || this.uploading || this.loadError || !this.studentData || !this.selectedFiles.size) return;
    const student = this.studentData;
    const pending = this.files.filter(file => this.selectedFiles.has(file.id) && !this.studentHasDoc(student, file.id));
    this.sending = true;
    let sent = 0;
    try {
      for (const file of pending) {
        await this.studentProv.admCustomerToggleFile({cid: student.id, fid: file.id});
        student.files = (student.files || []).concat({file_id: file.id});
        sent++;
        if (this.studentData && this.studentData.id === student.id) this.selectedFiles.delete(file.id);
      }
    } catch (error) {
      this.toastr.error('Não foi possível concluir o envio. Os arquivos pendentes continuam selecionados para tentar novamente.', '', this.helpers.toastrCfgs);
    } finally {
      this.sending = false;
      if (sent) {
        this.filesUpdated.emit({id: student.id, files: student.files});
        this.toastr.success(sent + (sent === 1 ? ' arquivo enviado para ' : ' arquivos enviados para ') + student.name, '', this.helpers.toastrCfgs);
      }
    }
  }

  async removeFile(file: any) {
    if (this.loading || this.sending || this.removingFileId != null || this.uploading || this.loadError ||
        !this.studentHasDoc(this.studentData, file.id)) return;
    const student = this.studentData;
    this.removingFileId = file.id;
    try {
      await this.studentProv.admCustomerToggleFile({cid: student.id, fid: file.id});
      student.files = (student.files || []).filter(item => String(item.file_id) !== String(file.id));
      if (this.studentData && this.studentData.id === student.id) this.selectedFiles.delete(file.id);
      this.filesUpdated.emit({id: student.id, files: student.files});
      this.toastr.success('Arquivo removido de ' + student.name, '', this.helpers.toastrCfgs);
    } catch (error) {
      this.toastr.error('Não foi possível remover o arquivo. Tente novamente.', '', this.helpers.toastrCfgs);
    } finally {
      this.removingFileId = null;
    }
  }

  async uploadFile(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';
    if (!file || this.uploading || this.sending || this.removingFileId != null || this.loading || this.loadError) return;
    if (!/\.pdf$/i.test(file.name) || (file.type && file.type !== 'application/pdf')) {
      this.toastr.error('Selecione um arquivo PDF.', '', this.helpers.toastrCfgs);
      return;
    }
    const studentId = this.studentData && this.studentData.id;
    this.uploading = true;
    try {
      const subscription: any = await this.userProv.subscriptions();
      const plan = String(subscription.purchase && subscription.purchase.supertreinos_plan_id);
      const limits = {'0': [0, 0], '1': [2, 2], '2': [10, 10], '3': [20, 100], '4': [20, 400]};
      const limit = limits[plan] || [20, 20];
      const capacity = subscription.files && subscription.files.max != null ? Number(subscription.files.max) : limit[1];
      const used = this.files.reduce((total, item) => total + (Number(item.size) || 0), 0);
      if (file.size > limit[0] * 1024 * 1024 || used + file.size > capacity * 1024 * 1024) {
        this.toastr.error('O arquivo excede o limite por PDF ou o espaço disponível do seu plano.', '', this.helpers.toastrCfgs);
        return;
      }
      const data = new FormData();
      data.append('userpdf', file, file.name);
      data.append('id', String(this.auth.retrieveLocalUser().id));
      const response: any = await this.fileProv.post(data);
      const previousIds = new Set(this.files.map(item => item.id));
      this.files = response.files || this.files;
      if (this.studentData && this.studentData.id === studentId) {
        this.files.filter(item => !previousIds.has(item.id)).forEach(item => this.selectedFiles.add(item.id));
        this.search = '';
        this.activeFilter = 'all';
      }
      this.toastr.success('PDF carregado. Selecione e confirme o envio para o aluno.', '', this.helpers.toastrCfgs);
    } catch (error) {
      this.toastr.error('Não foi possível carregar o PDF. Tente novamente.', '', this.helpers.toastrCfgs);
    } finally {
      this.uploading = false;
    }
  }

  loading: boolean = false;
  files = [];
  arquivos = [];

  PAGE: any;
  STRINGS: any;

  constructor(
    public toastr: ToastrService,
    public auth: AuthService,
    public api: ApiProvider,
    public helpers: HelpersProvider,
    public dialog: MatDialog,
    // private route: ActivatedRoute,
    public studentProv: CustomerProvider,
    public userProv: UserProvider,
    public fileProv: FileProvider,
    public i18n: I18nProvider,
  ) {
    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('CustomerFilesComponent');

    this.headers = {'Authorization': `Bearer ${localStorage.getItem('LoggedInUser')}`};

  }
  ngOnInit() {
    // console.log('notes ok');
    // console.log(this.studentData);
    // this.getFiles(this.studentData.id);
    // this.getFilesList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.studentData) {
      this.selectedFiles.clear();
      this.search = '';
      this.activeFilter = 'all';
      this.getFilesList();
    }
  }

  async getFilesList() {
    const student = this.studentData;
    const version = ++this.loadVersion;
    if (!student || !student.id) { this.files = []; this.loading = false; return; }
    this.loading = true;
    this.loadError = false;
    try {
      const results: any[] = await Promise.all([
        this.fileProv.index(), this.studentProv.getUserFiles(student.id)
      ]);
      if (version !== this.loadVersion) return;
      this.files = results[0].files || [];
      student.files = results[1].files || [];
      this.reorderFiles();
    } catch (error) {
      if (version !== this.loadVersion) return;
      this.loadError = true;
      this.files = [];
      this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
    } finally {
      if (version === this.loadVersion) this.loading = false;
    }
  }

  async getFiles(id: number = 0) {
    const student = this.studentData;
    try {
      const res: any = await this.studentProv.getUserFiles(id);
      if (!student || this.studentData !== student || student.id !== id) return;
      student.files = res.files || [];
      this.reorderFiles();
      this.filesUpdated.emit({id, files: student.files});
    } catch (error) {
      this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
      this.loading = false;
    }
  }

  reorderFiles() {
    // ordena os arquivos de acordo com a selecao do aluno
    if (this.studentData.files.length === 0) {
      this.loading = false;
      return false;
    }

    const stdfiles = [];
    const loosefiles = [];
    this.studentData.files.forEach(sFile => {
      this.files.sort((x,y) => {
        if (x.id === sFile.file_id) {
          return -1;
        } else if (y.id === sFile.file_id) {
          return 1;
        } else {
          return 0;
        }
      })
    });
    this.loading = false;
  }

  studentHasDoc(student: any, file_id: number): boolean {
    return !!student && (student.files || []).some(file => String(file.file_id) === String(file_id));
  }

  removeStudentFile(fid: number) {
    const msg = this.PAGE.remover_arquivo;
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '360px',
      data: {title: this.PAGE.remover_arquivo_titulo, message: msg, confirmation: 'deletar'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'deletar') {
        this.loading = true;
        const data = {
          cid: this.studentData.id,
          fid: fid
        };
        this.studentProv.admCustomerToggleFile(data).then(
          (_res: any) => {
            this.toastr.success(this.PAGE.lista_arquivo_sucesso, '', this.helpers.toastrCfgs);
            this.getFiles(this.studentData.id);
          },
          (err: any) => {
            console.log(err)
            this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
            this.loading = false;
          }
        );
      }
    });
  }

  toggleActiveProgram(cid: number, fid: number) {
    const data = {
      cid: cid,
      fid: fid
    };
    this.studentProv.admCustomerToggleFile(data).then(
      (_res: any) => {
        // this.loading = false;
        // this.students = res.customers;
        this.toastr.success(this.PAGE.lista_arquivo_sucesso, '', this.helpers.toastrCfgs);
      },
      (err: any) => {
        console.log(err);
        this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
        this.loading = false;
      }
    );
  }

  toggleDocStudent(file: any, student: any) {
    this.toggleActiveProgram(student.id, file.id);
  }

  checkSlideValue(slide: any) {
    return slide._checked;
  }

  helpFile() {
    let msg = '';
    msg += '<img src="assets/imgs/ajuda-arquivos.png">';

    const dialogRef = this.dialog.open(DialogLightComponent, { width: '70vw', data: { message: msg } });
    dialogRef.afterClosed().subscribe(_result => {});
  }

  helpAllFiles() {
    let msg = this.PAGE.ajuda_arquivos;

    const dialogRef = this.dialog.open(DialogLightComponent, { width: '360px', data: { message: msg } });
    dialogRef.afterClosed().subscribe(_result => {});
  }

}
